import { render, staticRenderFns } from "./NameAddress.vue?vue&type=template&id=2bd05ae6"
import script from "./NameAddress.vue?vue&type=script&lang=js"
export * from "./NameAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports